<template>
  <div class="navigate-arrow">
    <button
      v-if="isFirstStep"
      key="start"
      class="navigate-arrow__button navigate-arrow__button--start"
      @click="next()"
    >
      <svg viewBox="0 0 49.0904 51.4358">
        <path
          fill="currentColor"
          d="M8.1711,4.7142A2.8138,2.8138,0,0,0,3.7589,1.2251c-12.4785,16.6,11.08,27.87-.2856,46.0339A2.7946,2.7946,0,1,0,8.36,49.9719C20.8577,28.9-1.2768,16.4417,8.1711,4.7142Z"
        />
        <path
          fill="currentColor"
          d="M26.66,4.6361A2.8666,2.8666,0,0,0,22.1164,1.147C9.4757,17.5225,33.0974,28.91,21.7574,47.1018A2.8552,2.8552,0,0,0,26.73,49.9065C39.2054,28.644,16.9424,16.2387,26.66,4.6361Z"
        />
        <path
          fill="currentColor"
          d="M45.2839,21.0091c-2.6416-6.4414-4.55-11.0957-.1973-16.3027,2.2469-2.9659-2.2595-6.5274-4.6309-3.6356C27.9772,17.68,51.5413,28.9356,40.1642,47.1164a2.8833,2.8833,0,0,0,5.0465,2.79C52.0915,37.9564,48.33,28.5912,45.2839,21.0091Z"
        />
      </svg>
      {{ $t('start.button') }}
    </button>
    <div v-if="!isFirstStep" key="arrows" class="navigate-arrows">
      <button
        class="navigate-arrow__button navigate-arrow__button--arrow navigate-arrow__button--prev"
        @click="prev()"
      >
        <svg viewBox="0 0 50 50">
          <path
            d="M0 25C0 38.8071 11.4356 50 25.542 50C28.5274 50 31.3931 49.6995 34.0561 48.7783C36.7191 47.857 41.6911 42.7711 50 42.7711V7.12851C42.9221 7.12851 37.7489 2.4283 34.2612 1.22174C31.5982 0.300482 28.5274 0 25.542 0C11.4356 0 0 11.1929 0 25Z"
            fill="white"
          />
          <path
            d="M2.91968 25.0003C2.91968 37.3228 13.0913 47.3121 25.6387 47.3121C28.294 47.3121 30.843 47.044 33.2116 46.2218C35.5803 45.3996 41.7883 40.8605 49.1788 40.8605V9.05048C42.8832 9.05048 36.4963 4.85567 33.3941 3.77885C31.0255 2.95665 28.294 2.68848 25.6387 2.68848C13.0913 2.68848 2.91968 12.6778 2.91968 25.0003Z"
            class="navigate-arrow__svg-button-bg"
          />
          <path
            d="M19.1606 24.731L27.7373 32.7955V16.6665L19.1606 24.731Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <button
        v-if="!isLastStep"
        class="navigate-arrow__button navigate-arrow__button--arrow navigate-arrow__button--next"
        @click="next()"
      >
        <svg viewBox="0 0 50 50">
          <path
            d="M50 25C50 38.8071 38.5644 50 24.458 50C21.4726 50 18.6069 49.6995 15.9439 48.7783C13.2809 47.857 8.30886 42.7711 0 42.7711V7.12851C7.07792 7.12851 12.2511 2.4283 15.7388 1.22174C18.4018 0.300482 21.4726 0 24.458 0C38.5644 0 50 11.1929 50 25Z"
            fill="white"
          />
          <path
            d="M47.0803 25.0003C47.0803 37.3228 36.9087 47.3121 24.3613 47.3121C21.706 47.3121 19.157 47.044 16.7884 46.2218C14.4197 45.3996 8.21171 40.8605 0.821198 40.8605V9.05048C7.11682 9.05048 13.5037 4.85567 16.6059 3.77885C18.9745 2.95665 21.706 2.68848 24.3613 2.68848C36.9087 2.68848 47.0803 12.6778 47.0803 25.0003Z"
            class="navigate-arrow__svg-button-bg"
          />
          <path
            d="M30.8394 24.731L22.2627 32.7955V16.6665L30.8394 24.731Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <button
        v-else
        class="navigate-arrow__button navigate-arrow__button--arrow navigate-arrow__button--next"
        @click="submit()"
      >
        <svg viewBox="0 0 50 50">
          <path
            d="M50 25C50 38.8071 38.5644 50 24.458 50C21.4726 50 18.6069 49.6995 15.9439 48.7783C13.2809 47.857 8.30886 42.7711 0 42.7711V7.12851C7.07792 7.12851 12.2511 2.4283 15.7388 1.22174C18.4018 0.300482 21.4726 0 24.458 0C38.5644 0 50 11.1929 50 25Z"
            fill="white"
          />
          <path
            d="M47.0803 25.0003C47.0803 37.3228 36.9087 47.3121 24.3613 47.3121C21.706 47.3121 19.157 47.044 16.7884 46.2218C14.4197 45.3996 8.21171 40.8605 0.821198 40.8605V9.05048C7.11682 9.05048 13.5037 4.85567 16.6059 3.77885C18.9745 2.95665 21.706 2.68848 24.3613 2.68848C36.9087 2.68848 47.0803 12.6778 47.0803 25.0003Z"
            class="navigate-arrow__svg-button-bg"
          />
          <path
            d="M18.9446 28.7653L31.9566 26.9708L34 19.0526H15.494L14.5687 16.4625C14.4916 16.185 14.2024 16 13.894 16H10V17.3875H13.3928L18.0193 30.4119C18.1157 30.6894 18.3855 30.8744 18.694 30.8744H32.0145V29.4869H19.2145L18.9446 28.7653Z"
            fill="currentColor"
          />
          <path
            d="M30.2795 35C31.2058 35 31.9566 34.2794 31.9566 33.3905C31.9566 32.5015 31.2058 31.7809 30.2795 31.7809C29.3533 31.7809 28.6024 32.5015 28.6024 33.3905C28.6024 34.2794 29.3533 35 30.2795 35Z"
            fill="currentColor"
          />
          <path
            d="M19.6964 35C20.6226 35 21.3735 34.2794 21.3735 33.3905C21.3735 32.5015 20.6226 31.7809 19.6964 31.7809C18.7701 31.7809 18.0193 32.5015 18.0193 33.3905C18.0193 34.2794 18.7701 35 19.6964 35Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import Steps from '@/class/Steps';
import { NavigationDirection } from '@/models/navigation-direction';

export default new Steps({}).comp;
</script>

<style lang="scss">
.navigate-arrow,
.navigate-arrows {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100px;
  width: 266px;

  box-sizing: border-box;
}

.navigate-arrow__button {
  display: block;

  border: none;
  background: transparent;
  padding: 0;
  margin: 0;

  width: 100px;
  height: 100px;

  color: black;
  cursor: pointer;
  transition: color 150ms ease-in-out;
  box-sizing: border-box;

  .navigate-arrow__svg-button-bg {
    fill: $green;
    transition: 150ms ease-in-out;
  }

  &:hover,
  &:focus {
    outline: none;
  }

  &:hover {
    color: white;
  }
}

.navigate-arrow__button--start {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding: 10px;

  background-color: $green;
  border: 4px solid white;
  border-radius: 50%;

  text-transform: uppercase;
  font-size: 20px;
  letter-spacing: 1px;

  svg {
    width: 20px;
    margin-bottom: 6px;
  }
}

@media (min-width: 460.89px) {
  .navigate-arrow__button--start {
    border-width: 8px;
  }
}

@media (min-width: 992.89px) {
  .navigate-arrow {
    height: 150px;
    width: 400px;
  }
  .navigate-arrow__button {
    width: 150px;
    height: 150px;
  }
  .navigate-arrow__button--start {
    font-size: 35px;

    svg {
      width: 30px;
      margin: 5px;
    }
  }
}
</style>
